(function() {
	'use strict';

	angular.module('app.leanProjects')
		.directive('tasksSection', tasksSection);

	tasksSection.$inject = ['$rootScope'];

	function tasksSection($rootScope) {
		return {
			restrict: 'EA',
			templateUrl: '/application/f/lean-projects/projects/tasks-section.html',
			scope: {
				projectNdx: '@projectNdx',
				leanDirFactoryNdx: '@leanDirFactoryNdx',
				managerNdx: '@managerNdx',
				projectState: '@projectState',
				insidePanel: '@insidePanel',
				authzInfo: '=',
				details: '=',
				viewTaskNdx: '='
			},
			controller: tasksSectionController,
			controllerAs: 'tasksSectionController',
			bindToController: true
		};
	}

	tasksSectionController.$inject = ['$scope', '$rootScope', '$uibModal', '$timeout', '$experiments' ,'editProjectService', 'leanProjectAuthService', 'taskFormService', 'leanTableService', 'leanFilterService'];
	function tasksSectionController($scope, $rootScope, $uibModal, $timeout, $experiments, editProjectService, leanProjectAuthService, taskFormService, leanTableService, leanFilterService) {
		var vm = this;
		var defaultFilter = {
			id: 'taskStatus',
			value: 'ACT'
		};
		var defaultDateOptions = [
			{'id': '0', 'display':'No Change', 'sequence': 0, 'days': 0, 'moment': {'key':'days', 'value': 0}},
			{'id': '7', 'display':'7 Days Forward', 'sequence': 1, 'days': 7, 'moment': {'key':'days', 'value': 7}},
			{'id': '14', 'display':'14 Days Forward', 'sequence': 2, 'days': 14, 'moment': {'key':'days', 'value': 14}},
			{'id': 'nextMonth', 'display':'Same Day Next Month', 'sequence': 3, 'days': 30, 'moment': {'key':'months', 'value': 1}},
			{'id': 'nextFiscalQuarter', 'display':'Same Day Next Fiscal Quarter', 'sequence': 4, 'days': 90, 'moment': {'key':'months', 'value': 3}},
			{'id': 'nextFiscalYear', 'display':'Same Day Next Fiscal Year', 'sequence': 5, 'days': 365, 'moment': {'key':'years', 'value': 1}},
			{'id': 'customForward', 'display':'Custom Days Forward', 'sequence': 6, 'days': 0},
			{'id': 'customBackward', 'display':'Custom Days Backward', 'sequence': 7, 'days': 0}
		];
		var advancedDateFields = [
			'originalStartDate',
			'originalDueDate',
			'actualStartDate',
			'actualCompletionDate'
		];

		vm.reportConfig = {};
		vm.tableService = leanTableService;
		vm.tableService.setReportSettingsName('viewProjectTasksFilter');
		var rootScope = $rootScope;
		vm.tasks = [];
		vm.tasksList = [];
		vm.selectedTaskStatus = '';
		vm.taskStatus = [
			{ndx: 'AT', text: 'Active tasks only'},
			{ndx: 'ACT', text: 'Active and completed tasks'}
		];
		vm.selectedTaskStatus = 'ACT';
		vm.updateTaskGrid = updateTaskGrid;
		vm.actionIsAllowed = actionIsAllowed;
		vm.addTask = addTask;
		vm.editTask = editTask;
		vm.lateTask = lateTask;
		vm.deleteTask = deleteTask;
		vm.tasksFilter = tasksFilter;
		vm.ganttView = ganttView;
		vm.toggleCheckboxRow = toggleCheckboxRow;
		vm.toggleAllCheckboxes = toggleAllCheckboxes;
		vm.currentlyNoneSelected = currentlyNoneSelected;
		vm.editTaskDates = editTaskDates;
		vm.updateProjectActivity = updateProjectActivity;
		vm.showHeaderToggle = false;
		vm.headerCheckboxClass = 'fa-square-o';
		vm.addAttachment = addAttachment;
		vm.goToAttachments = goToAttachments;
		leanFilterService.defaultFilters = [defaultFilter];

		function lateTask(taskCompletionDate, taskState) {
			var today = new Date().setHours(0,0,0,0);
			taskCompletionDate = new Date(taskCompletionDate);
			if( taskState === 'Pending' || taskState === 'Started'){
				if( taskCompletionDate < today) {
					return true;
				}
			}
			return false;
		}

		function updateTaskGrid(taskState, saveFilterState, reload) {
			vm.reportConfig.filters = [];
			defaultFilter.value = taskState;
			vm.reportConfig.filters.push(defaultFilter);
			if(typeof saveFilterState === 'undefined' || saveFilterState){
				updateFilterConfig(vm.reportConfig);
			}
			var viewTask = null;
			if (typeof reload !== 'undefined' && reload) {
				editProjectService.getTasks(vm.projectNdx, vm.leanDirFactoryNdx, taskState).then(function(tasks) {
					if(tasks && tasks.length > 0) {
						angular.forEach(tasks, function(task) {
							task.projectedStartDate = new Date(task.projectedStartDate);
							task.projectedCompleteDate = new Date(task.projectedCompleteDate);
							var projectedStartDateLocal = moment(task.projectedStartDate).add(task.projectedStartDate.getTimezoneOffset(), 'minutes');
							task.projectedStartDate = moment(projectedStartDateLocal)._d;
							var projectedCompleteDateLocal = moment(task.projectedCompleteDate).add(task.projectedCompleteDate.getTimezoneOffset(), 'minutes');
							task.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;
							if (vm.viewTaskNdx !== 0 && task.ndx === vm.viewTaskNdx) {
								viewTask = task;
							}
							task.responsibleDisplay = task.firstName + ' ' + task.lastName;

							if (task.stateType === 'Pending' && actionIsAllowed('editTask', task.taskResponsibleId)) {
								vm.showHeaderToggle = true;
								task.hasCheckBox = true;
								task.checkbox = false;
							}
						});
					}
					vm.tasksList = tasks;
					vm.tasks = [].concat(vm.tasksList);

					if (viewTask != null) {
						vm.viewTaskNdx = 0;
						editTask(viewTask);
					}
					$timeout(function () {
						updateSelectAllBox();
					}, 0);
					$scope.$emit('tasksLoaded');
				});
			}
			
		}

		function actionIsAllowed(action, responsibleNdx) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details, responsibleNdx);
		}

		function updateFilterConfig(config) {
			vm.tableService.updateConfig(config, true);
		}

		function getTaskData(config, filterState) {
			vm.reportConfig = config;
			angular.forEach(config.filters, function(filter) {
				if (filter.id === 'taskStatus') {
					if (filter.value === 'ACAT') {
						filter.value = 'ACT';
						filterState = true;
					}
					vm.selectedTaskStatus = filter.value;
					updateTaskGrid(filter.value, false, true);
				}
			});
		}

		function addTask(callback, projectTaskGroupId) {
			var taskFormScope = $rootScope.$new();
			taskFormScope.action = 'Add';
			taskFormScope.projectNdx = vm.projectNdx;
			taskFormScope.leanDirFactoryNdx = vm.leanDirFactoryNdx;
			taskFormScope.projectTaskGroupId = projectTaskGroupId;
			taskFormScope.details = vm.details;
			var opts = {
				scope: taskFormScope,
				templateUrl: '/application/f/lean-projects/projects/task-form/task-form.html',
				size: 'sm',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			taskFormScope.closeDialog = function() {
				instance.close();
				taskFormScope.$destroy();
			};

			taskFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful) {
					// $scope.$broadcast('taskCreated', {});
					updateProjectActivity();
					if (callback) {
						callback();
					}
				}
				if (isSuccessful || message === '') {
					instance.close();
					taskFormScope.$destroy();
				}
			};
		}

		function editTask(task, viewTask) {
			var taskFormScope = $rootScope.$new();
			taskFormScope.task = jQuery.extend({}, task);
			taskFormScope.task.description = taskFormScope.task.description;
			taskFormScope.task.action = taskFormScope.task.action;
			taskFormScope.action = 'Edit';
			taskFormScope.viewMode = !actionIsAllowed('editTask', task.taskResponsibleId);
			taskFormScope.projectNdx = vm.projectNdx;
			taskFormScope.leanDirFactoryNdx = vm.leanDirFactoryNdx;
			taskFormScope.details = vm.details;
			var opts = {
				scope: taskFormScope,
				templateUrl: '/application/f/lean-projects/projects/task-form/task-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			taskFormScope.closeDialog = function() {
				instance.close();
				taskFormScope.$destroy();
			};

			taskFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful && message != '') {
					updateProjectActivity();
					// updateTaskGrid(vm.selectedTaskStatus, false, true);
					if (task.callback) {
						task.callback();
					}
				}
				if (isSuccessful || message == '') {
					instance.close();
					taskFormScope.$destroy();
				}
			};
		}

		function deleteTask(taskNdx, callback) {
			var confirmScope = $rootScope.$new();
			confirmScope.taskNdx = taskNdx;
			confirmScope.additionalText = 'delete this task' + (globalConfig.user.role === 'Supplier' ? '' : ' and any associated attachments');
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var taskNdx = confirmScope.taskNdx;
				instance.close();
				confirmScope.$destroy();
				taskFormService.deleteTask(taskNdx, vm.projectNdx, vm.leanDirFactoryNdx).then(function(message) {
					var isSuccessful = (message == 'Task deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful) {
						updateProjectActivity(true);
						// updateTaskGrid(vm.selectedTaskStatus, false, true);
						if (callback) {
							callback();
						}
					}
				});
			};
		}

		vm.tableService.getConfig(true).then(function(config) {
			var updateFilters = false;
			if (config.filters.length == 0) {
				config.filters.push(defaultFilter);
				updateFilters = true;
			}
			getTaskData(config, updateFilters, true);
		});

		$scope.$on('taskCreated', function( event, data ){
			updateTaskGrid(vm.selectedTaskStatus, false, true);
		});

		$rootScope.$on('reloadTasks', function (event) {
			updateTaskGrid(vm.selectedTaskStatus, false, true);
		});

		function tasksFilter(tasksStatus) {
			if (tasksStatus == 'AT') {
				return function( item ) {
					return item.stateType == 'Pending' || item.stateType == 'Started';
				};
			} else {
				return function( item ) {
					return true;
				};
			}
		}
		
		function ganttView(projectTasks) {
			var ganttScope = $scope.$new();
			ganttScope.action = 'Add';
			ganttScope.projectNdx = vm.projectNdx;
			ganttScope.leanDirFactoryNdx = vm.leanDirFactoryNdx;
			ganttScope.tasks = projectTasks || vm.tasks;
			var opts = {
				scope: ganttScope,
				templateUrl: '/application/f/lean-projects/projects/task-gantt.html',
				windowTemplateUrl: '/application/f/lean-projects/metric/report-card-template.html',
				backdrop: true
			};

			var instance = $uibModal.open(opts);
			ganttScope.closeDialog = function () {
				instance.close();
				ganttScope.$destroy();
			};

			ganttScope.result = function () {
				instance.close();
				ganttScope.$destroy();
			};
		}

		// Checkbox functions

		function updateSelectAllBox() {
			var notAllSelected = _.filter(vm.tasks, function (task) {
				return task.hasCheckBox && !task.checkbox;
			}).length;
			var notNoneSelected = getSelectedTaskForEdit().length;
			var newClass = '';
			if (notAllSelected && notNoneSelected) {
				newClass = 'fa-minus-square';
			} else if (notAllSelected) {
				newClass = 'fa-square-o';
			} else {
				newClass = 'fa-check-square';
			}
			vm.headerCheckboxClass = newClass;
		}

		function toggleCheckboxRow($row) {
			if ($row) {
				$row['checkbox'] = !$row.checkbox;
			}
			$timeout(function () {
				updateSelectAllBox();
			}, 0);
		}

		function selectAllCheckboxes() {
			angular.forEach(vm.tasks, function (row) {
				if (row.hasCheckBox) {
					row.checkbox = true;
				}
			});
			vm.headerCheckboxClass = 'fa-check-square';
		}

		function deselectAllCheckboxes() {
			angular.forEach(vm.tasks, function (row) {
				row.checkbox = false;
			});
			vm.headerCheckboxClass = 'fa-square-o';
		}

		function toggleAllCheckboxes() {
			var anySelected = getSelectedTaskForEdit().length;
			if (anySelected) {
				deselectAllCheckboxes($scope, $timeout);
			} else {
				selectAllCheckboxes($scope, $timeout);
			}
		}

		function currentlyNoneSelected() {
			if (!vm.tasks || !vm.tasks.length) return true;
			for (var i = 0; i < vm.tasks.length; i++) {
				if (vm.tasks[i].checkbox) return false;
			}
			return true;
		}

		function getSelectedTaskForEdit() {
			return _.filter(vm.tasks, function(task) {
				return task.checkbox;
			});
		}

		function editTaskDates(projectTasks, datesType, isAdvancedDateControlShown, callback) {
			vm.isAdvancedDateControlShown = isAdvancedDateControlShown;
			processDateUpdateFields(datesType);
			var editTaskDatesFormScope = $scope.$new();
			editTaskDatesFormScope.startDateOptions = _.clone(defaultDateOptions);
			editTaskDatesFormScope.dueDateOptions = filterOutNoChange(_.filter(_.clone(defaultDateOptions)));

			editTaskDatesFormScope.filterDueDates = filterDueDates;
			editTaskDatesFormScope.hasError = hasError;
			editTaskDatesFormScope.save = save;
			editTaskDatesFormScope.selected = {};
			editTaskDatesFormScope.noOfSelectedTasks = projectTasks ? projectTasks.length : getSelectedTaskForEdit().length;
			editTaskDatesFormScope.editDatesTitle = vm.editDatesTitle;
			editTaskDatesFormScope.editStartDateLabel = vm.editStartDateLabel;
			editTaskDatesFormScope.editDueDateLabel = vm.editDueDateLabel;
			var opts = {
				scope: editTaskDatesFormScope,
				templateUrl: '/application/f/lean-projects/projects/task-form/edit-task-dates-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			editTaskDatesFormScope.closeDialog = function() {
				instance.close();
				editTaskDatesFormScope.$destroy();
			};

			editTaskDatesFormScope.result = function(message, isSuccessful) {
			};

			function filterOutNoChange(options, excludeBackward) {
				return _.filter(options, function (option) {
					return option.id !== '0' && !(excludeBackward && option.id === 'customBackward');
				});
			}

			function filterOutAllExceptBackward(options) {
				return _.filter(options, function (option) {
					return option.id === 'customBackward';
				});
			}

			function filterDueDates($item) {
				if ($item.id === 'customForward') {
					editTaskDatesFormScope.dueDateOptions = filterOutNoChange(_.clone(defaultDateOptions), true);
					editTaskDatesFormScope.selected.startDateDaysForward = 15;
					editTaskDatesFormScope.selected.endDateDaysForward = 15;
				} else if ($item.id === 'customBackward') {
					editTaskDatesFormScope.dueDateOptions = filterOutAllExceptBackward(_.clone(defaultDateOptions));
					editTaskDatesFormScope.selected.startDateDaysForward = 15;
					editTaskDatesFormScope.selected.endDateDaysForward = 15;
				} else {
					editTaskDatesFormScope.dueDateOptions = _.filter(defaultDateOptions, function(data) {
						return data.sequence >= $item.sequence && data.id !== '0' && data.id !== 'customBackward';
					});
				}
				editTaskDatesFormScope.selected.dueDate = $item.id === '0' ? null : $item.id;
			}

			function getNoOfDays(option, daysForward) {
				var noOfDays = 0;
				if (option) {
					if (option === 'customForward' ||  option === 'customBackward') {
						if (daysForward) {
							noOfDays = daysForward;
						}
					} else {
						noOfDays = _.find(defaultDateOptions, {
							id: option
						}).days;
					}
				}

				return noOfDays;
			}

			function hasError() {
				var noOfStartDateDays = getNoOfDays(editTaskDatesFormScope.selected.startDate, editTaskDatesFormScope.selected.startDateDaysForward);
				var noOfDueDateDays = getNoOfDays(editTaskDatesFormScope.selected.dueDate, editTaskDatesFormScope.selected.endDateDaysForward);

				if (editTaskDatesFormScope.selected.startDate === 'customBackward'){
					if (noOfDueDateDays > noOfStartDateDays) {
						editTaskDatesFormScope.errorMessage = 'Start Date days backward Value must equal or exceed Due Date days backward';
						return true;
					}
					return false;
				} else if (noOfDueDateDays < noOfStartDateDays) {
					editTaskDatesFormScope.errorMessage = 'Due Date Value must equal or exceed Start Date days forward';
					return true;
				} else {
					editTaskDatesFormScope.errorMessage = '';
				}
				return false;
			}

			function save() {
				vm.editTaskDatesSelection = _.clone(editTaskDatesFormScope.selected);
				editTaskDatesFormScope.closeDialog();
				showTaskWithDatesChanges(projectTasks, callback, datesType);
			}
		}

		function addNewDate(task, existingDate, option, daysForward) {
			var date = task[existingDate];
			if (option && date) {
				if (option === 'customForward') {
					task[existingDate + '_new'] = moment(date).add(daysForward, 'days');
				} else if (option === 'customBackward') {
					task[existingDate + '_new'] = moment(date).subtract(daysForward, 'days');
				} else {
					var dateOption = _.find(defaultDateOptions, {
						id: option
					})['moment'];
					task[existingDate + '_new'] = moment(date).add(dateOption.value, dateOption.key);
				}
			}
		}

		function showTaskWithDatesChanges(projectTasks, callback, datesType) {
			var tasks = projectTasks || getSelectedTaskForEdit();

			angular.forEach(tasks, function (task) {
				cleanupDatesForState(datesType, task);
				addNewDate(task, vm.startDateField, vm.editTaskDatesSelection.startDate,
					vm.editTaskDatesSelection.startDateDaysForward);
				addNewDate(task, vm.endDateField, vm.editTaskDatesSelection.dueDate,
					vm.editTaskDatesSelection.endDateDaysForward);
				if (datesType === 'actual') {
					var today = moment().startOf('day');
					if ((task[vm.startDateField + '_new'] && task[vm.startDateField + '_new'].startOf('day').isAfter(today)) ||
						(task[vm.endDateField + '_new'] && task[vm.endDateField + '_new'].startOf('day').isAfter(today))) {
						task[vm.startDateField + '_new'] = null;
						task[vm.endDateField + '_new'] = null;
					}
				}
			});
			var editTaskDatesConfirmFormScope = $scope.$new();
			editTaskDatesConfirmFormScope.tasks = tasks;
			editTaskDatesConfirmFormScope.startDateField = vm.startDateField;
			editTaskDatesConfirmFormScope.endDateField = vm.endDateField;
			editTaskDatesConfirmFormScope.isSaveButtonDisabled = false;
			editTaskDatesConfirmFormScope.confirmDatesTitle = vm.confirmDatesTitle;
			editTaskDatesConfirmFormScope.confirmCurrentStartDateLabel = vm.confirmCurrentStartDateLabel;
			editTaskDatesConfirmFormScope.confirmNewStartDateLabel = vm.confirmNewStartDateLabel;
			var opts = {
				scope: editTaskDatesConfirmFormScope,
				templateUrl: '/application/f/lean-projects/projects/task-form/edit-task-dates-details-confirm-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			editTaskDatesConfirmFormScope.closeDialog = function() {
				instance.close();
				editTaskDatesConfirmFormScope.$destroy();
			};

			editTaskDatesConfirmFormScope.save = function () {
				editTaskDatesConfirmFormScope.isSaveButtonDisabled = true;
				var cleanedTasks = getCleanedTasks(tasks);

				if(cleanedTasks.length) {
					taskFormService.updateTasks(cleanedTasks, vm.projectNdx, vm.leanDirFactoryNdx)
						.then(function (message) {
							if (message === 'Tasks updated successfully') {
								broadCastProjectStatusUpdate(true);
								$rootScope.$emit('toast', {'message': 'Tasks dates updated successfully', 'success': true});
								if (callback) {
									callback();
								}
							} else {
								$rootScope.$emit('toast', {'message': 'Failed to update task dates', 'success': false});
							}

							updateTaskGrid(vm.selectedTaskStatus, false, true);
							updateProjectActivity();
						});
				}
				editTaskDatesConfirmFormScope.closeDialog();
			};

			function getCleanedTasks(tasks) {
				var cleanedTasks = [];
				angular.forEach(tasks, function (task) {
					var cleanedTask = cleanUpTaskObject(task);
					var lastModified = (new Date()).getTime();
					if (typeof task.lastModified !== 'undefined') {
						lastModified = (new Date(task.lastModified)).getTime();
					}
					cleanedTask['lastModified'] = lastModified;
					if (!task[vm.startDateField] && !task[vm.endDateField]) {
						return;
					}
					cleanedTasks.push(cleanedTask);
				});
				return cleanedTasks;
			}
			function cleanUpTaskObject(task) {
				var taskObj = jQuery.extend({}, task);
				var startDate = taskObj[vm.startDateField + '_new'] ? taskObj[vm.startDateField + '_new']._d : new Date(taskObj[vm.startDateField]);
				var dueDate = taskObj[vm.endDateField + '_new'] ? taskObj[vm.endDateField + '_new']._d : new Date(taskObj[vm.endDateField]);

				var dueDateUtc = moment(dueDate)
					.subtract(dueDate.getTimezoneOffset(), 'minutes');
				taskObj[vm.endDateField] = moment(dueDateUtc)._d;

				var startDateUtc = moment(startDate)
					.subtract(startDate.getTimezoneOffset(), 'minutes');
				taskObj[vm.startDateField] = moment(startDateUtc)._d;
				cleanupAdvancedDates(taskObj);

				delete taskObj.firstName;
				delete taskObj.lastName;
				delete taskObj.responsible;
				delete taskObj.responsibleStatus;
				delete taskObj[vm.startDateField + '_new'];
				delete taskObj[vm.endDateField + '_new'];
				delete taskObj.hasCheckBox;
				delete taskObj.checkbox;
				delete taskObj.responsibleDisplay;
				delete taskObj.taskState;
				delete taskObj.origCmpltDate;
				delete taskObj.selected;
				delete taskObj.responsibleName;
				return taskObj;
			}

			function updateProjectDueDate(updateDate) {
				if (vm.dueDateAfterProjectDueDate && updateDate) {
					var projectedCompleteDateLocal = moment(vm.task.projectedCompleteDate).add(vm.task.projectedCompleteDate.getTimezoneOffset(), 'minutes');
					vm.task.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;
					vm.details.endDate = moment(vm.task.projectedCompleteDate).valueOf();
				}
			}

			function broadCastProjectStatusUpdate(dueDateChange) {
				$scope.$emit('updateLastModified', {
					'dueDateChange': true
				});
			}
		}

		function updateProjectActivity(reloadProject) {
			$rootScope.$emit('activityUpdated');
			if (reloadProject) {
				$scope.$emit('updateLastModified');
			}
		}

		function addAttachment(taskNdx) {
			$scope.$emit('addAttachment', {
				'taskNdx': taskNdx
			});
		}

		function goToAttachments() {
			$scope.$emit('goToAttachment');
		}

		function processDateUpdateFields(datesType) {
			if (datesType === 'current') {
				vm.startDateField = 'projectedStartDate';
				vm.endDateField = 'projectedCompleteDate';

				vm.editDatesTitle = vm.isAdvancedDateControlShown ? 'Edit Current Task Dates' : 'Edit Task Dates';
				vm.editStartDateLabel = 'Start Date';
				vm.editDueDateLabel = 'Due Date';

				vm.confirmDatesTitle = vm.isAdvancedDateControlShown ? 'Confirm Edit Revised Dates' : 'Confirm Edit Task Dates';
				vm.confirmCurrentStartDateLabel = vm.isAdvancedDateControlShown ? 'Current Revised Start' : 'Current Start';
				vm.confirmNewStartDateLabel = vm.isAdvancedDateControlShown ? 'New Revised Start' : 'New Start';
			} else if (datesType === 'original') {
				vm.startDateField = 'originalStartDate';
				vm.endDateField = 'originalDueDate';

				vm.editDatesTitle = 'Edit Original Task Dates';
				vm.editStartDateLabel = 'Original Start Date';
				vm.editDueDateLabel = 'Original Due Date';

				vm.confirmDatesTitle = 'Confirm Edit Original Dates';
				vm.confirmCurrentStartDateLabel = 'Current Original Start';
				vm.confirmNewStartDateLabel = 'New Original Start';
			} else if (datesType === 'actual') {
				vm.startDateField = 'actualStartDate';
				vm.endDateField = 'actualCompletionDate';

				vm.editDatesTitle = 'Edit Actual Task Dates';
				vm.editStartDateLabel = 'Actual Start Date';
				vm.editDueDateLabel = 'Actual Completion Date';

				vm.confirmDatesTitle = 'Confirm Edit Actual Dates';
				vm.confirmCurrentStartDateLabel = 'Current Actual Start';
				vm.confirmNewStartDateLabel = 'New Actual Start';
			}
		}

		function cleanupDatesForState(datesType, task) {
			if (datesType === 'actual') {
				if (task.stateType === 'Pending') {
					task.actualStartDate = null;
					task.actualCompletionDate = null;
				} else if (task.stateType === 'Started') {
					task.actualCompletionDate = null;
					if (!task.actualStartDate) {
						task.actualStartDate = new Date();
					}
				} else if (task.stateType === 'Completed') {
					if (!task.actualStartDate) {
						task.actualStartDate = new Date();
					}
					if (!task.actualCompletionDate) {
						task.actualCompletionDate = new Date();
					}
				}
			}
		}

		function cleanupAdvancedDates(task) {
			advancedDateFields
				.filter(function (dateField) {
					return !task[dateField + '_new'];
				})
				.forEach(function (dateField) {
					task[dateField] = null;
				});
		}
	}
})();
